import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { cn } from '../../../utils/utils';
import CrossIcon from '../../../icons/cross';
import { IconButton } from '../IconButton';
const SEGMENT = 'whitespace-nowrap px-2.5 py-1.5 font-roobert text-sm leading-4 outline-none';
// `value` turns red while the Root is invalid, so an unfinished part shows where it is.
const EMPHASIS = {
    label: 'font-medium text-neutral-900',
    muted: 'text-neutral-500',
    value: 'text-neutral-900 group-data-[invalid]/chip:text-red-500'
};
// A chip split into segments, e.g. field · operator · value of a rule condition.
const Root = ({ invalid = false, className, ...props }) => (_jsx("span", { ...props, "data-invalid": invalid ? '' : undefined, className: cn('group/chip inline-flex items-stretch divide-x divide-solid overflow-hidden rounded-md border border-solid bg-white shadow-sm', invalid
        ? 'divide-red-200 border-dashed border-red-300'
        : 'divide-neutral-200 border-neutral-200', className) }));
// A part that only reads; an icon placed before the text gets its gap.
const Segment = ({ emphasis = 'value', className, ...props }) => (_jsx("span", { ...props, className: cn(SEGMENT, 'inline-flex cursor-default items-center gap-1.5', EMPHASIS[emphasis], className) }));
// A part that opens something. Render it from a PopoverTrigger, MenuTrigger or
// ComboboxTrigger (`render={<SegmentedChip.Trigger />}`) to wire it up.
const Trigger = forwardRef(function Trigger({ emphasis = 'value', className, ...props }, ref) {
    return (_jsx("button", { type: "button", ...props, ref: ref, className: cn(SEGMENT, 'hover:bg-neutral-100 focus-visible:bg-neutral-100', EMPHASIS[emphasis], className) }));
});
const Remove = ({ removeLabel, className, ...props }) => (_jsx(IconButton, { ...props, size: "sm", "aria-label": removeLabel, className: cn('mx-0.5 self-center [&>svg]:size-2.5', className), children: _jsx(CrossIcon, { color: "currentColor" }) }));
export const SegmentedChip = { Root, Segment, Trigger, Remove };
